import { INTEGRATION_SYSTEM_NAME } from "@/constants";

export const entities = ["test", "testset", "requirement", "issue"];

export const mapEntities: Record<string, string> = {
  QtestDesign: "test",
  Suite: "testset",
  Requirement: "requirement",
  Issue: "issue",
  Instance: "instance",
  Milestone: "milestone",
  QtestRun: "run",
};

export const getKeyByValue = (
  obj: Record<string, unknown>,
  value: unknown,
): string | undefined => {
  return Object.entries(obj).find(([, val]) => val === value)?.[0];
};

export const NEW_SECTION_LABEL_PLACEHOLDER = "New Section";
export const isCustomField = (fieldId: string) => fieldId.startsWith("__");
export const isSystemField = (fieldId: string) => !isCustomField(fieldId);
export const isAvailableField = (fieldId: string) =>
  String(fieldId).startsWith("available-");
export const isSectionField = (fieldId: string) =>
  String(fieldId).startsWith("field-");
export const isIntegrationSection = (section?: { system_section?: string }) =>
  section?.system_section === INTEGRATION_SYSTEM_NAME;

export const getTypeLabel = (type: string | undefined): string => {
  if (!type) return "Text";
  let label = type;

  switch (type) {
    case "linkedlist":
      label = "Linked List";
      break;
    case "linked_milestones":
      label = "Linked Milestones";
      break;
    default:
      label = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  }

  return label || "Text";
};
